import React, { useContext, useEffect, useState } from 'react';
import { UserInfoContext, UserRoleContext } from '../App';
import { isGuild, dynamicImportImages, hiddoClickHOF } from '../util';
import styled from 'styled-components';

const isEmpty = require('lodash/isEmpty');

interface Info {
  title: string;
  link: string;
  descriptions: string[];
  hiidoActType: string;
}

const GuildManageItem: React.FC<Info> = ({
  title,
  link,
  descriptions,
  hiidoActType
}) => {
  const StyledIcon = styled.i<{ name: string }>`
    background-image: ${props =>
      `url(${dynamicImportImages(`./${props.name}.png`)})`};
  `;

  return (
    <li className="guild-manage-item">
      <a
        className="guild-manage-item__link"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        onClick={hiddoClickHOF(hiidoActType)}
      >
        <StyledIcon name={title} className="guild-manage-item__icon" />
        <br />
        <p className="guild-manage-item__title">{title}</p>

        {descriptions.map((x, idx) => (
          <p key={idx} className="guild-manage-item__desc">
            {x}
          </p>
        ))}
      </a>
    </li>
  );
};

const commonInfos = [
  {
    title: '成为公会',
    link: '//www.yy.com/gh/cl/?a=1',
    descriptions: ['快速成为YY公会，享受YY公', '会权益'],
    hiidoActType: '3'
  },
  {
    title: '公会成长与权益',
    link: '//www.yy.com/web/pages/guild_grown_and_equity/index.html',
    descriptions: ['了解公会等级成长体系，海量', '资源扶持与高效管理工具'],
    hiidoActType: '4'
  },
  {
    title: '直播学院',
    link: '//www.yy.com/web/live_school/#/home',
    descriptions: ['官方助力，带你全面了解YY直播生态', '提高主播直播技巧与公会自运营能力'],
    hiidoActType: '5'
  },
  {
    title: '帮助中心',
    link: '//kf.yy.com/faq/list/12-9.html',
    descriptions: ['收集公会相关答疑问题，帮助', '您快速了解YY公会'],
    hiidoActType: '6'
  }
];
const getGuildExtraInfos = (guildYY: string) => [
  {
    title: '公会管理中心',
    link: '//www.yy.com/gi?path=/i/index/anchor&hash=',
    descriptions: ['高效管理主播，掌握公会整', '体运营情况'],
    hiidoActType: '7'
  },
  {
    title: '公会资源中心',
    link: '//www.yy.com/gi/guild-resource',
    descriptions: ['整合公会所有资源，支持公', '会快速申请官方资源'],
    hiidoActType: '8'
  },
  {
    title: '公会数据中心',
    link: '//www.yy.com/guild/datacenter/',
    descriptions: ['展示公会和主播收入、开播', '等所有重要数据'],
    hiidoActType: '9'
  },
  {
    title: '公会主页管理',
    link: `//www.yy.com/gu/${guildYY}`,
    descriptions: ['管理与编辑公会主页，对外', '展示公会信息'],
    hiidoActType: '10'
  }
];

const GuildManage = () => {
  const userRole = useContext(UserRoleContext);
  const userInfo = useContext(UserInfoContext);
  const [infos, setInfos] = useState<Info[]>(commonInfos);

  useEffect(() => {
    if (isGuild(userRole) && !isEmpty(userInfo)) {
      setInfos([
        ...commonInfos,
        ...getGuildExtraInfos(userInfo.yy_num as string)
      ]);
    }
  }, [userRole, userInfo]);

  return (
    <div className="guild-manage-wrap">
      <ul className="guild-manage-list">
        {infos.map((x, idx) => (
          <GuildManageItem key={idx} {...x} />
        ))}
      </ul>
    </div>
  );
};

export default GuildManage;
